/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createRangeFees,
  getNewOtherFeesList,
  history,
  getSingleNewOtherFees,
  getRangeCalculationList,
  creating,
  ordinanceRevisionId,
  newOtherFeesId,
  rangeCalculationList,
}) {
  const [formData, setFormData] = useState({
    from: '',
    to: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    from: 'required',
    to: 'required',
    amount: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
    };

    createRangeFees(newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
      getSingleNewOtherFees(newOtherFeesId);
      getRangeCalculationList(newOtherFeesId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // check the first there's an existing business type then retun object of data, if no existing business type available, return {}
  // const checkBusinessTypeData = selectedBusinessType => rangeCalculationList.find(type => type.attributes.business_type === selectedBusinessType) || {}

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              From: {validateForm.renderMessage('from')}
            </label>
            <input
              className="form-control"
              type="text"
              name="from"
              // disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'from')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              To: {validateForm.renderMessage('to')}
            </label>
            <input
              className="form-control"
              type="text"
              name="to"
              // disabled={!_.isEmpty(checkBusinessTypeData(_.get(formData, "business_type")))}
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'to')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                const props = {
                  target: {
                    name: 'amount',
                    value,
                  },
                };
                onChange(props);
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  createRangeFees: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getRangeCalculationList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  rangeCalculationList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_RANGE_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
